import React from "react";

export default function Suggestion() {
    return (
        <>
        </>
    )
}